import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const WAIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="WA" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
        <Path fill="#2E42A5" d="M0 0v7h8V0H0Z" />
        <Path
          fill="#FEFFFF"
          d="m1.783 3.886-.53.32.12-.625-.44-.467.597-.025.253-.583.253.583h.596l-.44.492.132.625-.541-.32ZM5.783 3.886l-.53.32.12-.625-.44-.467.597-.025.253-.583.253.583h.596l-.44.492.132.625-.541-.32ZM3.733 2.069l-.5.301.115-.588-.416-.44.563-.023.238-.549.238.549h.561l-.414.463.125.588-.51-.301ZM4.273 4.213l-.312.188.071-.367-.26-.275.352-.015.15-.343.148.343h.35l-.258.29.078.367-.319-.188ZM3.704 6.414l-.748.452.17-.882-.622-.66.843-.035.357-.823.357.823h.843l-.622.695.187.882-.765-.452Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
